import { Component, ViewChild, OnInit, Injectable, Input } from "@angular/core";
import { DataSource } from "@angular/cdk/collections";
import { MdPaginator, MdSnackBar } from "@angular/material";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/startWith";
import "rxjs/add/observable/merge";
import "rxjs/add/operator/map";
import { AuthService } from "../../../../../services/auth.service";
import { ComponentInterface } from "../../models/component.interface";
import { DocumentModel } from "../../../../../models/documents/document.model";
import { DashboardService } from "../../../../../services/dashboard.service";
import { SharedService } from "../../../../../services/shared.service";

import dictionary from "../../../../../utils/dictionary.json";
import { UserModel } from "../../../../../models/user/user.model";

@Component({
  selector: "app-structured-data",
  templateUrl: "./structured-data.component.html",
  styleUrls: ["./structured-data.component.css"],
})
export class StructuredDataComponent implements OnInit, ComponentInterface {
  @Input() config;

  private _user: UserModel;
  title: string = "";
  subtitle: string = "";

  displayedColumns = [];

  isLoading: boolean = false;
  missingData: boolean = false;
  isTable: boolean = true;
  rowCount: number = 0;
  data: any[] = null;
  count: number = 0;
  responseTypes: Array<any>;

  constructor(
    private _dashboardService: DashboardService,
    private _sharedService: SharedService,
    public _authService: AuthService,
    private snackBar: MdSnackBar
  ) {
    this._user = _authService.user;
  }

  @ViewChild(MdPaginator) paginator: MdPaginator;
  dataSource: StructureddataDataSource = new StructureddataDataSource(
    [],
    this.paginator
  );
  cardSource: Array<any> = [];

  ngOnInit() {
    this.responseTypes = this._sharedService.getResponseTypes();
    if (!this.responseTypes) {
      this._dashboardService.getResponseTypes().subscribe((res) => {
        this.responseTypes = res;
        this._sharedService.setResponseTypes(res);
      });
    }
    this._dashboardService
      .getBloccoSlider(this.config.token)
      .subscribe((blocco) => {
        this.isLoading = false;
        this.isTable = blocco.routeAnagrafica.idBloccoHttpResponseTipo === 2;
        const method = blocco.routeAnagrafica.verbo;
        const params = this.getParmas(blocco);
        const json = blocco.json;
        const rotta = blocco.routeAnagrafica.rotta;
        this.title = blocco.titolo;
        this.subtitle = blocco.sottotitolo;
        let url = rotta;
        if (params) {
          url = `${url}?${params}`;
        }
        if (method === "GET") {
          this._dashboardService.getHttpData(url).subscribe((res) => {
            if (this.isTable) {
              this.data = res;
            } else {
              this.count = res;
            }
            this.isLoading = false;
          });
        }
        if (method === "POST") {
          this._dashboardService.postHttpData(url, json).subscribe((res) => {
            if (this.isTable) {
              this.data = res;
            } else {
              this.count = res;
            }
            this.isLoading = false;
          });
        }
        // const resType = this.responseTypes.find(
        //   (type) => type.id === blocco.routeAnagrafica.idBloccoHttpResponseTipo
        // );
        // console.log(resType);
        const block = {
          ...blocco,
          data: [
            {
              id: "id1",
              name: "name1",
              type: "type1",
              key1: "value1-1",
              key2: "value2-1",
            },
            {
              id: "id2",
              name: "name2",
              type: "type2",
              key1: "value1-2",
              key2: "value2-2",
            },
            {
              id: "id3",
              name: "name3",
              type: "type3",
              key1: "value1-3",
              key2: "value2-3",
            },
          ],
        };
        this.displayedColumns = Object.keys(block.data[0]);
        this.dataSource = new StructureddataDataSource(
          block.data,
          this.paginator
        );
        this.cardSource = block.data.map((item) => {
          return Object.entries(item);
        });
        this.rowCount = block.data.length;
        this.isLoading = false;
      });
  }

  dataSourceToString() {
    return JSON.stringify(this.dataSource);
  }

  getParmas(blocco) {
    let queryString = blocco.bloccoHTTPDataUserDefined
      .map((item) => {
        const el = dictionary.find((element) => element.name === item.valore);
        let valore = item.valore;
        if (el) {
          valore = this._user[el.value];
          if (el.value.startsWith("@")) {
            valore = this.getDateParmas(el.value).toString();
          }
          if (!valore) {
            this.missingData = true;
            this.showError(
              "Per poter utilizzare questa funzionalità, è necessario scegliere l'unità di vendita/zona interessata attraverso la voce di menù 'Cambia Uv Zona (per ROLWEB)'"
            );
            return;
          } else {
            this.missingData = false;
          }
        }
        return `${item.nome}=${valore}`;
      })
      .join("&");
    return queryString;
  }

  private getDateParmas(value: string) {
    switch (value) {
      case "@anno@":
        return new Date().getFullYear();
      case "@mese@":
        return new Date().getMonth() + 1;
      case "@giorno@":
        return new Date().getDate();
      default:
        return undefined;
    }
  }

  goTo() {}

  private showError(message: string) {
    this.snackBar.open("Errore: " + message, "Chiudi", { duration: 5000 });
  }
}

export class StructureddataDataSource extends DataSource<any> {
  constructor(
    //private _incassiService: IncassiService,
    private data: any[],
    private _paginator: MdPaginator
  ) {
    super();
  }

  connect(): Observable<DocumentModel[]> {
    return Observable.of(this.data);
  }

  disconnect() {}
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/structured-data/structured-data.component.ts